import { render, staticRenderFns } from "./balance-trans-detail.vue?vue&type=template&id=2320cc6e&scoped=true"
import script from "./balance-trans-detail.vue?vue&type=script&lang=js"
export * from "./balance-trans-detail.vue?vue&type=script&lang=js"
import style0 from "./balance-trans-detail.vue?vue&type=style&index=0&id=2320cc6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320cc6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2320cc6e')) {
      api.createRecord('2320cc6e', component.options)
    } else {
      api.reload('2320cc6e', component.options)
    }
    module.hot.accept("./balance-trans-detail.vue?vue&type=template&id=2320cc6e&scoped=true", function () {
      api.rerender('2320cc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/financials-agent/balance-trans-detail.vue"
export default component.exports